import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Home from './components/home';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const pageName = urlParams.get("page")

if (process.env.NODE_ENV !== 'development') {
  console.log = () => {}
}

ReactDOM.render(
    pageName === "game" ? <App /> : <Home/>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
